/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */

/**
 *
 *
 * 1 = Finance
 *
 * 2 = Cash
 */
export enum FinancePaymentType {
  Finance = 1,
  Cash = 2,
}
